import script from "./Matter.vue?vue&type=script&lang=ts&setup=true"
export * from "./Matter.vue?vue&type=script&lang=ts&setup=true"

import "./Matter.vue?vue&type=style&index=0&id=1f05bd1d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f05bd1d"]])

export default __exports__